import React from "react";

export const IconPublicTransport = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m16.5 1.5h-9c-1.2426 0-2.25 1.0074-2.25 2.25v12c0 1.2426 1.0074 2.25 2.25 2.25h9c1.2426 0 2.25-1.0074 2.25-2.25v-12c0-1.2426-1.0074-2.25-2.25-2.25z"
      stroke="#000"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="m9.75 3.75h4.5"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m17.25 6h-10.5c-0.82843 0-1.5 0.67157-1.5 1.5v1.5c0 0.82843 0.67157 1.5 1.5 1.5h10.5c0.8284 0 1.5-0.67157 1.5-1.5v-1.5c0-0.82843-0.6716-1.5-1.5-1.5z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m8.25 15.75c0.41421 0 0.75-0.3358 0.75-0.75s-0.33579-0.75-0.75-0.75-0.75 0.3358-0.75 0.75 0.33579 0.75 0.75 0.75z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m15.75 15.75c0.4142 0 0.75-0.3358 0.75-0.75s-0.3358-0.75-0.75-0.75-0.75 0.3358-0.75 0.75 0.3358 0.75 0.75 0.75z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m7.5 21.75h9m-0.75-1.5 2.25 2.25m-9.75-2.25-2.25 2.25"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconPublicTransport;
